import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import AnimatedText from "../components/animation";
import FadeInOnScroll from "../components/scrollanimation";

// phone country code:

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';



import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

import FacebookLogin from '@greatsumini/react-facebook-login';
// image
// import allyhome from '../assets/ally-big.webp'

function Register() {
  const navigate = useNavigate();


  
 // country code 
   const [phone, setPhone] = useState(""); 
   const [selectedCountry, setSelectedCountry] = useState({ dialCode: "91" }); // Default to India
 // Hide ? Show Password 
     const [showPassword, setShowPassword] = useState(false); 
  // Confirmation modal state
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationEmail, setConfirmationEmail] = useState("");
  const [confirmationCode, setConfirmationCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);

// API Base URL 
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://ted-talk-phi.vercel.app/api";
  const API_AUTH_SIGNUP = `${API_BASE_URL}/auth/signup`;
  const API_AUTH_CONFIRM = `${API_BASE_URL}/auth/confirm-signup`;
  const API_AUTH_GOOGLE = `${API_BASE_URL}/auth/google-signup`; // We'll create this endpoint
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID";

const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();


  // Extract country code and mobile number from PhoneInput value
  // const extractPhoneParts = (phoneValue, countryData) => {
  //   if (!phoneValue) {
  //     return { countryCode: "+91", mobileNumber: "" };
  //   }
    
  //   // Use the stored selectedCountry 
  //   const countryInfo = countryData || selectedCountry || { dialCode: "91" };
  //   const dialCode = countryInfo.dialCode?.toString() || "91";
  //   const countryCode = `+${dialCode}`;
    
  //   // Remove dial code from the start to get mobile number
  //   let mobileNumber = phoneValue.toString();
  //   if (mobileNumber.startsWith(dialCode)) {
  //     mobileNumber = mobileNumber.substring(dialCode.length);
  //   }
    
  //   return { countryCode, mobileNumber };
  // };



const extractPhoneParts = (phoneValue, countryData) => {
  if (!phoneValue) {
    return { countryCode: "+91", mobileNumber: "" };
  }

  const dialCode = countryData?.dialCode || "91";
  const countryCode = `+${dialCode}`;

  // Remove all non-digits
  let number = phoneValue.replace(/\D/g, "");

  // Remove dial code
  if (number.startsWith(dialCode)) {
    number = number.slice(dialCode.length);
  }

  return {
    countryCode,
    mobileNumber: number,
  };
};



  // Submit Handler
  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const { countryCode, mobileNumber } = extractPhoneParts(phone, selectedCountry);
      
      // Validate phone number
      if (!phone || !mobileNumber || mobileNumber.length < 10) {
        alert("Please enter a valid 10-digit phone number");
        setIsSubmitting(false);
        return;
      }
      
      const signupData = {
        firstName: data.firstName,
        lastName: data.lastName,
        businessEmailAddress: data.businessEmailAddress,
        password: data.password,
        countryCode: countryCode,
        mobileNumber: mobileNumber,
        category: data.category,
        howDidYouHear: data.howDidYouHear
      };

      const response = await fetch(API_AUTH_SIGNUP, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(signupData),
      });

      let result;
      try {
        result = await response.json();
      } catch (e) {
        const text = await response.text();
        throw new Error(text || "Server error occurred");
      }

      if (response.ok) {
        if (result.confirmationRequired) {
          setConfirmationEmail(signupData.businessEmailAddress);
          setShowConfirmationModal(true);
        } else {
          alert("Registration successful! You can now sign in.");
          navigate("/login");
        }
      } else {
        alert(result.message || result.error || "Something went wrong!");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Network error! Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleConfirmSignup = async () => {
    setIsConfirming(true);
    try {
      const response = await fetch(API_AUTH_CONFIRM, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: confirmationEmail,
          confirmationCode: confirmationCode,
        }),
      });

      let result;
      try {
        result = await response.json();
      } catch (e) {
        const text = await response.text();
        throw new Error(text || "Server error occurred");
      }

      if (response.ok) {
        alert("Email confirmed successfully! You can now sign in.");
        setShowConfirmationModal(false);
        navigate("/login");
      } else {
        alert(result.message || result.error || "Invalid confirmation code. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert(error.message || "Network error! Please try again later.");
    } finally {
      setIsConfirming(false);
    }
  };




// Social Media Login 
// ////// Google Login 
   const GooglehandleSuccess = async (credentialResponse) => {
    try {
      setIsSubmitting(true);
      console.log("Google Credential:", credentialResponse);
      
      const response = await fetch(`${API_BASE_URL}/auth/google-signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          credential: credentialResponse.credential,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        // Store tokens 
        if (result.accessToken) {
          localStorage.setItem("accessToken", result.accessToken);
          localStorage.setItem("idToken", result.idToken);
          localStorage.setItem("refreshToken", result.refreshToken);
        }
        alert("Google signup successful!");
        navigate("/dashboard");
      } else {
        if (response.status === 404) {
          alert("Google signup endpoint not yet configured. Please use email signup for now.");
        } else {
          alert(result.message || "Google signup failed. Please try again.");
        }
      }
    } catch (error) {
      console.error("Google signup error:", error);
      alert("Google signup is not yet available. Please use email signup.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const GooglehandleError = () => {
    console.log("Google Login Failed");
    alert("Google signup failed. Please try again or use email signup.");
  };


//   ///// Facebook Login API

  const FacebookhandleSuccess = (response) => {
    console.log('Facebook login success:', response);
    // Send response.accessToken to your backend
  };

  const FacebookhandleFail = (error) => {
    console.log('Facebook login failed:', error);
  };

  const FacebookhandleProfileSuccess = (response) => {
    console.log('Facebook profile:', response);
  };

    return (
        <div>
            <Header />
            <main>
                <section className="hero">
                    <Container>
                        <Row>
                            <Col className="text-start">
                                    <FadeInOnScroll yOffset={100}>
                                    <h1 className="h1 hero-family">
                                    <AnimatedText text="Grow your business" animationType="fade-up" />

                                    <br /> <AnimatedText text="on" animationType="fade-up" /><b className="green-text"> <AnimatedText text="WhatsApp" animationType="fade-up" /></b></h1>
                                    <p>
                                    <AnimatedText text="Boost engagement and streamline communication with Ally—your AI-powered assistant that automates HR, support, and daily tasks, making interactions faster, smarter, and more personal." animationType="rotate" />
                                    </p>
                                    </FadeInOnScroll>
                                    <FadeInOnScroll yOffset={100}>
                                    <ul className="ul-List">
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>  Targeted Campaigns to deliver personalized offers</li>
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg> Pre-built templates to send updates & reminders</li>
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>24x7 instant engagement with no-code chatbots</li>
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>Powerful automations to resolve issues faster</li>
                                        <li><svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.83 5.78972L4.78628 8.00693C5.20476 8.32079 5.7944 8.2591 6.13886 7.86544L12 1.16699" stroke="#63cf90" stroke-width="2" stroke-linecap="round"></path></svg>Integrations to bring in context from Zoho, Shopify, etc.</li>
                                    </ul>
                                   </FadeInOnScroll>

                            </Col>
                            <Col className="text-start d-sm-flex justify-content-sm-center align-items-sm-center">
                                <div className="col-9">
                                   
                                    <div className="form-container contact-container">
                                        <h2>Start your free trial</h2>
                                        <p>Get started with a demo account on Ally</p>


                                        <div className="sc-fBuWsC dxzpwU">
    <div className="social-login__item">
             <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div>
        <GoogleLogin onSuccess={GooglehandleSuccess} onError={GooglehandleError} />
      </div>
    </GoogleOAuthProvider>
    </div>
    <div className="social-login__item">

                <FacebookLogin
                    appId="YOUR_FACEBOOK_APP_ID"
                    onSuccess={FacebookhandleSuccess}
                    onFail={FacebookhandleFail}
                    onProfileSuccess={FacebookhandleProfileSuccess}
                />
            
    </div>
</div>

<div className="form__divider">
    <span className="form__divider_text">or Sign up with Email</span>
</div>
                                      
                                        <form onSubmit={handleSubmit(onSubmit)} noValidate className="ally-registration-form">
                                           <Row>
                                             <Col className="col-6">
                                                    <Form.Control
                                                        type="text"
                                                         className="form-control"
                                                         placeholder="First Name"
                                                       {...register("firstName", { required: "First Name is required" })}
                                                    />
                                                     {errors.firstName && <p className="text-danger">{errors.firstName.message}</p>}
                                            </Col>

                                             <Col className="col-6">
                                              <Form.Control
                                                        type="text"
                                                         className="form-control"
                                                         placeholder="Last Name"
                                                       {...register("lastName", { required: "Last Name is required" })}
                                                    />
                                                     {errors.firstName && <p className="text-danger">{errors.firstName.message}</p>}
                                             </Col>      
                                           </Row>

                                                     <Col>
                                                          <label>Your Whatsapp Number - we'll reach out to you here*</label>
                                                            <Row className="mobile-no">
                                                              <div className="col-12">
                                                              <PhoneInput
                                                                  country={"in"} 
                                                                  value={phone}
                                                                  placeholder="Whatsapp Number is required"
                                                                  onChange={(value, country) => {
                                                                    setPhone(value);
                                                                    const countryInfo = country || { dialCode: "91", countryCode: "in" };
                                                                    setSelectedCountry(countryInfo);
                                                                    
                                                                    const dialCode = countryInfo.dialCode?.toString() || "91";
                                                                    const countryCode = `+${dialCode}`;
                                                                    
                                                                    let mobileNumber = value.toString();
                                                                    if (mobileNumber.startsWith(dialCode)) {
                                                                      mobileNumber = mobileNumber.substring(dialCode.length);
                                                                    }
                                                                    
                                                                    setValue("countryCode", countryCode, { shouldValidate: true });
                                                                    setValue("mobileNumber", mobileNumber, { shouldValidate: true });
                                                                  }}
                                                                  enableSearch={true}
                                                                  inputProps={{
                                                                    // name: "phone",
                                                                    required: true,
                                                                    autoFocus: false
                                                                  }}
                                                                />

                                                             
                                                         </div>
                                                            </Row>
                                                           
                                                            {phone && extractPhoneParts(phone, selectedCountry).mobileNumber.length < 10 && (
                                                              <p className="text-danger">Please enter a valid 10-digit phone number</p>
                                                            )}
                                                     </Col>

                                               
                                           
                                                <label>Please enter your Business Email*</label>
                                                    <Form.Control
                                                        type="email"
                                                         className="form-control"
                                                         placeholder="Your Business email Address"
                                                       {...register("businessEmailAddress", {
                                                            required: "Business email is required",
                                                            pattern: {
                                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                            message: "Enter a valid email address",
                                                            },
                                                        })}
                                                    />

                                                     {errors.email && <p className="text-danger">{errors.email.message}</p>}


                                                    <label>Minimum 8 char. (Include letters and numbers)</label>
                                                    <div className="position-relative">
                                                           <Form.Control
                                                       type={showPassword ? "text" : "password"}
                                                         className="form-control"
                                                         placeholder="password"
                                                       {...register("password", {
                                                            required: "Password is required",
                                                            minLength: {
                                                            value: 8,
                                                            message: "Password must be at least 8 characters",
                                                            },
                                                            pattern: {
                                                            value: /^(?=.*[A-Za-z])(?=.*\d).{8,}$/,
                                                            message:
                                                                "Password must include letters and numbers (min 8 characters)",
                                                            },
                                                        })}
                                                    />

                                                    {errors.password && <p className="text-danger">{errors.password.message}</p>}


                                                        <button className="viewpassword" onClick={() => setShowPassword(!showPassword)}>
                                                            {showPassword ? <svg className="MuiSvg" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="VisibilityIcon"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></svg> : <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="VisibilityOffIcon"><path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"></path></svg>}
                                                        </button>
                                                    </div>
                                                 
                                              
                                                <div className="dropdown position-relative">
                                                     <label>Primary team that will use Ally*</label>
                                                    <div className="position-relative">
                                                        <Form.Select
                                                         className="form-control"
                                                        {...register("category", { required: "Category is required" })}
                                                      >
                                                    <option value="">Select category</option>
                                                    <option value="Marketing">Marketing</option>
                                                    <option value="Sales">Sales</option>
                                                    <option value="Support">Support</option>
                                                    <option value="IT/Developer">IT/Developer</option>
                                                    <option value="Admin/Founder/Business Owner">Admin/Founder/Business Owner</option>
                                                    <option value="HR">HR</option>
                                                   </Form.Select>
                                                     <div className="viewpassword">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                                                 <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="dropdown position-relative">
                                                     <label>How did you hear about Ally*</label>
                                                    <div className="position-relative">
                                                        <Form.Select
                                                         className="form-control"
                                                        {...register("howDidYouHear", { required: "How did you hear about Ally is required" })}
                                                      >
                                                      <option value="">Your answer helps us reach users like you</option>
                                                      <option value="Google">Google</option>
                                                      <option value="Referral (Friend, Colleague)">Referral (Friend, Colleague)</option>
                                                      <option value="LLM (ChatGPT, Claude, Perplexity)">LLM (ChatGPT, Claude, Perplexity)</option>
                                                      <option value="Social (LinkedIn, Instagram, Twitter)">Social (LinkedIn, Instagram, Twitter)</option>
                                                      <option value="Ally Blog">Ally Blog</option>
                                                      <option value="Already knew about Ally">Already knew about Ally</option>
                                                      <option value="Review Sites (G2, Capterra)">Review Sites (G2, Capterra)</option>
                                                      <option value="Marketplaces (Zoho, Hubspot, Shopify)">Marketplaces (Zoho, Hubspot, Shopify)</option>
                                                      <option value="Don’t see your option above?">Don’t see your option above?</option>
                                                   </Form.Select>
                                                     <div className="viewpassword">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                                                 <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                                   
                                           <div className="col-12">
                                                    <p className="text-below">By signing up, You agree to the <a className="form__instruction-link" target="_blank" href="/terms-and-conditions">Terms &amp; Conditions</a> and <a className="form__instruction-link" target="_blank" href="/privacy-policy">Privacy Policy</a>  and consent to receive updates from Mystra.
                                                    </p>
                                                </div>
                                               
                                            <div className="button-group">
                                               
                                                <div className="button-grid">
                                                    <button type="submit" className="button mt-0" disabled={isSubmitting}>
                                                        {isSubmitting ? "Submitting..." : "Submit"}
                                                    </button>
                                                </div>
                                                
                                            </div>
                                        </form>
                                        <div className="col-12 mt-3">
                                             <div className="signup-login">Already have an account?&nbsp;<a className="register-link" href="/login">&nbsp; Sign in</a></div>
                                        </div>
                                    
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </Container>
                </section>
            </main>
            <Footer />

            {/* Confirmation Modal */}
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title>Confirm Your Email</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>We've sent a confirmation code to <strong>{confirmationEmail}</strong></p>
                <p>Please enter the code below to complete your registration.</p>
                <Form.Group className="mb-3">
                  <Form.Label>Confirmation Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter 6-digit code"
                    value={confirmationCode}
                    onChange={(e) => setConfirmationCode(e.target.value)}
                    maxLength={6}
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowConfirmationModal(false)}>
                  Cancel
                </Button>
                <Button 
                  variant="primary" 
                  onClick={handleConfirmSignup}
                  disabled={isConfirming || !confirmationCode}
                >
                  {isConfirming ? "Confirming..." : "Confirm"}
                </Button>
              </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Register;